<template>
  <v-card color="primary full-height">
    <v-icon v-if="showDragHandle" class="drag-handle move-cursor z-4" small>mdi-drag</v-icon>
    <v-img :src="fullUrl" contain style="min-height: 30px;" />
    <v-card-actions class="z-4" v-if="store.getters.permissionToWrite">
      <v-spacer />
      <v-btn :disabled="cloudinaryLoading" fab x-small color="primary" @click="editContent()">
        <v-icon>mdi-cog</v-icon>
      </v-btn>
      <v-btn :disabled="cloudinaryLoading" fab x-small color="primary" @click="emit('launch-cloudinary')">
        <v-icon>mdi-image-edit</v-icon>
      </v-btn>
      <v-btn :disabled="itemsLoading || cloudinaryLoading" fab x-small color="primary" @click="emit('delete-resource')">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text v-if="showFields && showFields.length">
      <section>
        <v-row>
          <h4 class="text-caption text-uppercase font-weight-light">Nom du fichier</h4>
          <p class=" white--text mb-2 force-wrap">{{ value.url.split('/').pop().split('.')[0] }}</p>
          <template v-for="(data, dataIndex) in showFields">
            <v-list-item
              v-if="data"
              :key="dataIndex"
              :class="[
                'px-0',
                { 'pt-1' : dataIndex != 0 }
              ]"
            >
              <div
                v-if="data"
                :key="dataIndex"
                class="px-0"
              >
                <h4 class="text-caption text-uppercase font-weight-light">{{ data.label }}</h4>
                <p class=" white--text mb-2 force-wrap">{{ value[data.field] || '----' }}</p>
              </div>
            </v-list-item>
          </template>
        </v-row>
      </section>
    </v-card-text>
    <EntityPopup
      ref="entityPopup"
      :raw-content-types="rawContentTypes"
      :content-type="contentType"
      :update="update"
    />
  </v-card>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import EntityPopup from '../Entity/EntityPopup.vue';
import { getMediaUrl } from '../../../utils/content';

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({
  value: { type: Object, default: null },
  itemsLoading: { type: Boolean, default: false },
  cloudinaryLoading: { type: Boolean, default: false },
  field: { type: Object, default: () => {} },
  rawContentTypes: { type: Object, default: () => {} },
  showDragHandle: { type: Boolean, default: false }
});

const store = useStore();

const entityPopup = ref(null);

const contentType = computed(() => (props.rawContentTypes[props.field.type]));

const fullUrl = computed(() => getMediaUrl(props.value.url, 'w_150,h_100,c_fill'));

const showFields = computed(() => {
  if (!contentType.value) {
    return [];
  }
  // eslint-disable-next-line no-unused-vars
  const show = Object.entries(contentType.value.fields).filter(([_, value]) => value.showInList).map(([key, value]) => ({ ...value, field: key }));
  return show;
});

const editContent = () => {
  entityPopup.value.editItem(props.value);
};

const update = value => {
  emit('input', value);
};

</script>

<style lang="scss" scoped>
.force-wrap {
  word-break: break-all;
  white-space: normal;
}
.v-card__actions {
  position: absolute;
  right: 0;
  top: 0;
}
.drag-handle {
  position: absolute;
  left: 0;
  top: 0;
  color: white;
}
.list-reset {
  list-style: none;
}
.loading {
    margin: 12px;
}

.full-height {
  height: 100%;
}

.z-4 {
  z-index: 4
}
</style>
